import { request } from "../libs";

function fetchSeversList() {
	return request(
		"/server",
		{ method: "GET" }
	)
		.then(res => res.json());
}

export default fetchSeversList;



// WEBPACK FOOTER //
// ./src/api/fetch-servers.js